const ScholarshipTypes = {
  ADD_COUNT: 'ADD_COUNT',
  SET_STEP: 'SET_STEP',
  SET_STEPS_COMPLETED: 'SET_STEPS_COMPLETED',
  SET_APPLICATION: 'SET_APPLICATION',
  SET_APPLICATION_ID: 'SET_APPLICATION_ID',
  FAILURE: 'FAILURE',
  APPLICATION_CREATE: 'APPLICATION_CREATE',
  APPLICATIONS_PAGINATE: 'APPLICATIONS_PAGINATE',
  APPLICATIONS_SHOWING: 'APPLICATIONS_SHOWING',
  APPLICATIONS_DATE: 'APPLICATIONS_DATE',
  APPLICATION_SAVE_START: 'APPLICATION_SAVE_START',
  APPLICATION_SAVE_SUCCESS: 'APPLICATION_SAVE_SUCCESS',
  APPLICATION_SAVE_FAILURE: 'APPLICATION_SAVE_FAILURE',
  APPLICATIONS_UPDATE_FILTER: 'APPLICATIONS_UPDATE_FILTER',
  APPLICATIONS_UPDATE_SORT: 'APPLICATIONS_UPDATE_SORT',
  APPLICATION_SET_FIELD: 'APPLICATION_SET_FIELD',
  DELETE_APPLICATION_START: 'DELETE_APPLICATION_START',
  DELETE_APPLICATION_FAILURE: 'DELETE_APPLICATION_FAILURE',
  DELETE_APPLICATION_SUCCESS: 'DELETE_APPLICATION_SUCCESS',
  FETCH_APPLICATION_START: 'FETCH_APPLICATION_START',
  FETCH_APPLICATION_SUCCESS: 'FETCH_APPLICATION_SUCCESS',
  FETCH_APPLICATIONS_START: 'FETCH_APPLICATIONS_START',
  FETCH_APPLICATIONS_SUCCESS: 'FETCH_APPLICATIONS_SUCCESS',
  FETCH_APPLICATIONS_FAILURE: 'FETCH_APPLICATIONS_FAILURE',
  FETCH_PROFILES_START: 'FETCH_PROFILES_START',
  FETCH_PROFILES_SUCCESS: 'FETCH_PROFILES_SUCCESS',
  FETCH_PROFILES_FAILURE: 'FETCH_PROFILES_FAILURE',
  RESEND_EMAIL_START: 'RESEND_EMAIL',
  RESEND_EMAIL_SUCCESS: 'RESEND_EMAIL_SUCCESS',
  RESEND_EMAIL_FAILURE: 'RESEND_EMAIL_FAILURE',
  RESEND_EMAIL_CLOSE: 'RESEND_EMAIL_CLOSE',
  RESEND_EMAIL_CLOSE_DIALOG: 'RESEND_EMAIL_CLOSE_DIALOG',
  SECTION_SAVE_START: 'SECTION_SAVE_START',
  SECTION_SAVE_SUCCESS: 'SECTION_SAVE_SUCCESS',
  SECTION_SAVE_TTPF: 'SECTION_SAVE_TTPF',
  SECTION_SAVE_ESSAY: 'SECTION_SAVE_ESSAY',
  SECTION_SAVE_FAILURE: 'SECTION_SAVE_FAILURE',
  PROFILE_SET_FIELD: 'PROFILE_SET_FIELD',
  PROFILE_CREATE: 'PROFILE_CREATE',
  PROFILE_DELETE: 'PROFILE_DELETE',
  PROFILE_SAVE_START: 'PROFILE_SAVE_START',
  PROFILE_SAVE_SUCCESS: 'PROFILE_SAVE_SUCCESS',
  PROFILE_SAVE_FAILURE: 'PROFILE_SAVE_FAILURE',
  MENTION_SAVE_START: 'MENTION_SAVE_START',
  MENTION_SAVE_SUCCESS: 'MENTION_SAVE_SUCCESS',
  MENTION_SAVE_FAILURE: 'MENTION_SAVE_FAILURE',
  SIGNATURE_SAVE_START: 'SIGNATURE_SAVE_START',
  SIGNATURE_SAVE_SUCCESS: 'SIGNATURE_SAVE_SUCCESS',
  SIGNATURE_SAVE_FAILURE: 'SIGNATURE_SAVE_FAILURE',
  SIGNATURE_UPSERT: 'SIGNATURE_UPSERT',
  SIGNATURE_DELETE: 'SIGNATURE_DELETE',
  USER_LOGOUT: 'USER_LOGOUT',
  FETCH_APPLICATION_FILES_START: 'FETCH_APPLICATION_FILE_START',
  FETCH_APPLICATION_FILES_SUCCESS: 'FETCH_APPLICATION_FILE_SUCCESS',
  FETCH_APPLICATION_FILES_FAILURE: 'FETCH_APPLICATION_FILE_FAILURE',
  APPLICATION_DELETE_FILE_SUCCESS: 'APPLICATION_DELETE_FILE_SUCCESS',
  APPLICATION_DELETE_FILE_START: 'APPLICATION_DELETE_FILE_START',
  APPLICATION_DELETE_FILE_FAILURE: 'APPLICATION_DELETE_FILE_FAILURE',
  APPLICATION_SAVE_ESSAY: 'APPLICATION_SAVE_ESSAY',
  APPLICATION_SAVE_TRANSCRIPT: 'APPLICATION_SAVE_TRANSCRIPT',
  APPLICATION_SAVE_SIGNATURE: 'APPLICATION_SAVE_SIGNATURE',
  ADD_PURCHASER_FAILURE: 'ADD_PURCHASER_FAILURE'
};

export default ScholarshipTypes;
